import { gcpStorageUrl } from 'consts'
import { Spin, Button } from 'antd'
import { useDispatch } from 'react-redux'
import Actions from 'actions'
import { isProduction } from 'utils/envUtils'

import './Page.css'

export const BackButton = ({ canNavigateBack = true }) => {
  const dispatch = useDispatch()
  if (!canNavigateBack) return
  const onNavigateBack = () => {
    dispatch(Actions.createAction(Actions.NAVIGATED_BACK))
  }
  return (
    <div className='back-btn' onClick={onNavigateBack}>
      <i className='icon-arrow-bold-left' />
    </div>
  )
}

export const SkipButton = ({ canSkip }) => {
  const dispatch = useDispatch()
  if (!canSkip) return
  const onSkip = () => {
    dispatch(Actions.createAction(Actions.DEBUG_SKIP_STEP))
  }
  return (
    <Button className='skip-btn' onClick={onSkip} type='link'>
      Skip
    </Button>
  )
}

const Page = ({
  className,
  children,
  title,
  subtitle,
  image,
  loading,
  backImage,
  canNavigateBack,
  canSkip
}) => {
  return loading ? (
    <Spin size='large' className='page-loading' />
  ) : (
    <div className={'page ' + className}>
      {image && (
        <img className='page-img' alt='' src={`${gcpStorageUrl}/${image}`} />
      )}
      <div className='row center'>
        <BackButton canNavigateBack={canNavigateBack} />
        <h1 className='title'>{title}</h1>
        <SkipButton canSkip={!isProduction && canSkip} />
      </div>
      {subtitle && <div className='subtitle'>{subtitle}</div>}
      <div className='content'>{children}</div>
      {backImage && (
        <img
          className='page-back-image'
          alt=''
          src={`${gcpStorageUrl}/${backImage}`}
        />
      )}
    </div>
  )
}

export default Page
